import React, { useState, useRef } from "react";
import { setSecureUser } from "../../utils/secureStorage";
import { Link } from "react-router-dom";
import axios from "axios";
import { SpinnerCircular } from "spinners-react";
import ReCAPTCHA from "react-google-recaptcha";
import "./login.css";
import CryptoJS from "crypto-js";

function LoginForm() {
  const [input, setInput] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const recaptchaRef = useRef();
  function handleInput(e) {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  }
  async function validateCaptcha(e) {
    e.preventDefault();

    const captchaValue = recaptchaRef.current.getValue();
    if (!captchaValue) {
      alert("Please verify the reCAPTCHA!");
      return;
    }

    setLoading(true);
    const url = `${process.env.REACT_APP_API}/secure/login`;

    // const url = `http://localhost:4000/secure/login`;

    const secretKey = process.env.REACT_APP_KEY;

    const encryptedEmail = CryptoJS.AES.encrypt(
      input.email,
      secretKey
    ).toString();
    const encryptedPassword = CryptoJS.AES.encrypt(
      input.password,
      secretKey
    ).toString();
    const data = {
      email: encryptedEmail,
      password: encryptedPassword,
      recaptcha: captchaValue,
    };

    try {
      const res = await axios.post(url, data, { withCredentials: true });

      setSecureUser(res.data);

      if (res.data.verification) {
        console.log("Redirecting to /student");
        window.location.hash = "/student";
      } else if (res.data.message) {
        console.log(`Message received: ${res.data.message}`);
        switch (res.data.message) {
          case "Email not verified":
          case "Mobile not verified":
          case "Admin not verified":
            console.log("Redirecting to /verification");
            window.location.hash = "/verification";
            break;
          default:
            console.error("Unexpected message:", res.data.message);
            setError("Unexpected response. Please try again.");
        }
      } else {
        console.error("No valid verification or message in response");
        setError("Unexpected response structure. Please try again.");
      }
    } catch (error) {
      console.error("Error during login request:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setError(error.response.data.message);
      } else {
        setError("Login failed! Please try again.");
      }
    } finally {
      setLoading(false);
    }
  }

  function route() {
    // Code for routing to forgot password page
  }



  return (
    <div className="login-container">
      <h2 id="heading">Login</h2>
      <p id="signup-link">
        Don't have an account?<Link to="/registration">SignUp</Link>
      </p>
      <form className="login-form" onSubmit={validateCaptcha}>
        <div className="input">
          <input
            type="text"
            placeholder="Email"
            name="email"
            className="user-details"
            id="email"
            onChange={handleInput}
          />
        </div>
        <div className="input">
          <input
            type="password"
            placeholder="Password"
            name="password"
            className="user-details"
            id="password"
            onChange={handleInput}
          />
        </div>

        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.REACT_APP_SITE_KEY_V2}
        />
        {loading ? (
          <div className="flex justify-center text-center">
            <SpinnerCircular
              size={35}
              color="#ffffff"
              thickness={100}
              speed={100}
            />
          </div>
        ) :
          <button id="log-button" className="user-details" onClick={validateCaptcha}>Login</button>
        }
        {error && <div className="error-div">{error}</div>}

        <div className="signUp-div">
          <p id="signup-link">
            Don't have an account?<Link to="/registration">SignUp</Link>
          </p>
          <Link
            to="/components/forms/forgetpassword"
            style={{ marginLeft: "11px" }}
            onClick={route}
          >
            Forgot Password?
          </Link>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
